import type { IBlockData, IInfoBlockData } from './types';

export const salesOverviewRow: IBlockData[] = [
  {
    title: 'TOTAL SALES',
    tooltipTitle: 'Total Sales',
    field: 'total_sales',
    change_field: 'change_pct',
    type: 'currency',
  },
  {
    title: 'PAID SALES',
    tooltipTitle: 'Sales from PPC (Pay Per Click) Ad Campaigns',
    field: 'paid_sales',
    change_field: 'paid_change_pct',
    type: 'currency',
  },
  {
    title: 'SNS',
    tooltipTitle: 'Sales from Subscribe & Save',
    field: 'sns_sales',
    change_field: 'sns_sales_change_pct',
    type: 'currency',
  },
  {
    title: 'ORGANIC SALES',
    tooltipTitle: 'Sales from Organic Search Rankings',
    field: 'organic_sales',
    change_field: 'organic_change_pct',
    type: 'currency',
  },
  {
    title: 'AVG. BBX %',
    field: 'bbx',
    change_field: 'bbx_change_pct',
    type: 'percent',
  },
];

export const infoBlock: IInfoBlockData[] = [
  {
    title: 'Traffic',
    blocks: [
      {
        title: 'Page Views',
        field: 'page_views',
        change_field: 'page_views_change_pct',
        type: 'number',
      },
      {
        title: 'Sessions',
        field: 'sessions',
        change_field: 'sessions_change_pct',
        type: 'number',
      },
      {
        title: 'BBX %',
        field: 'bbx',
        change_field: 'bbx_change',
        type: 'percent',
        decimal: true,
      },
      {
        title: 'CNV %',
        field: 'cnv',
        change_field: 'cnv_change',
        type: 'percent',
        tooltipTitle: 'Orders / Sessions',
        decimal: true,
      },
    ],
  },
  {
    title: 'PPC Sponsored Traffic',
    blocks: [
      {
        title: 'Impressions',
        field: 'paid_impr',
        change_field: 'paid_impr_change_pct',
        type: 'number',
        tooltipTitle: 'PPC Advertising impressions for the time frame',
      },
      {
        title: 'Clicks',
        field: 'paid_clicks',
        change_field: 'paid_clicks_change_pct',
        type: 'number',
        tooltipTitle: `<div>Clicks on Ads during the time frame.</div>
                      <div>Clickthrough Rate (Clicks / Impressions)</div>`,
        onlyCustomTooltip: true,
        formatPrevious: {
          field: 'paid_ctr',
          hideArrow: true,
          type: 'percent',
          decimal: true,
          extra: ' CTR',
        },
      },
      {
        title: 'Orders',
        field: 'paid_orders',
        change_field: 'paid_orders_change_pct',
        type: 'number',
        onlyCustomTooltip: true,
        tooltipTitle: `<div>Orders attributed to advertising during the time frame.</div> 
                       <div> Conversion Rate (Orders / Clicks)</div>`,
        formatPrevious: {
          field: 'paid_cnv',
          hideArrow: true,
          type: 'percent',
          decimal: true,
          extra: ' CNV',
        },
      },
      {
        title: 'Units',
        field: 'paid_units',
        change_field: 'paid_units_change_pct',
        type: 'number',
        tooltipTitle: 'Units sold attributed to advertising during the time frame',
      },
    ],
  },
  {
    title: 'ORDER DETAILS',
    blocks: [
      {
        title: 'Orders',
        field: 'total_orders',
        change_field: 'orders_change_pct',
        type: 'number',
        tooltipTitle: 'Total Orders',
      },
      {
        title: 'New to Brand',
        field: 'ntb',
        change_field: 'ntb_change_pct',
        type: 'number',
        tooltipTitle: 'FBA New to Brand Orders',
      },
      {
        title: 'Units',
        field: 'total_units',
        change_field: 'units_change_pct',
        type: 'number',
        tooltipTitle: 'Total Units Sold',
      },
      {
        title: 'Average Order Value',
        field: 'aov',
        change_field: 'aov_change_pct',
        type: 'currency',
        tooltipTitle: 'Average Order Value = Total Sales / Total Orders',
        decimal: true,
      },
    ],
  },
  {
    title: 'Subscribe & Save',
    blocks: [
      {
        title: 'Sales',
        field: 'sns_sales',
        change_field: 'sns_sales_change_pct',
        type: 'currency',
        tooltipTitle: 'Subscribe & Save revenue for the time frame',
      },
      {
        title: 'Units',
        field: 'sns_units',
        change_field: 'sns_units_change_pct',
        type: 'number',
        tooltipTitle: 'Subscribe & Save units shipped for the time frame',
      },
      {
        title: '+8 Week Estimates',
        field: 'wk8_units',
        change_field: 'wk8_units_change_pct',
        type: 'number',
        dataUse: 'sns',
        onlyCustomTooltip: true,
        hidePercent: true,
      },
      {
        title: 'Total Subscriptions',
        field: 'subscriptions',
        change_field: 'subscriptions_change_pct',
        type: 'number',
        dataUse: 'sns',
        onlyCustomTooltip: true,
        formatPrevious: {
          field: 'previous_subscriptions_change',
          hideArrow: true,
          type: 'number',
        },
      },
    ],
  },
];
